// ratingStars.js
import $ from "jquery";

module.exports = {
    initRatingStarsList: function () {

        let $ratingStars = $('.js-rating-stars--inline');

        function loadRatingHover(){
            $ratingStars.each(function() {
                let $this = $(this);
                let $stars = $this.find('.rating-stars__star--inline');
                let $input = $this.find('.rating-stars__hidden-value');

                let curSelectedVal = $stars.filter('.rating-stars__star--filled').length;
                if (curSelectedVal >= 1) curSelectedVal -= 1;

                $stars.hover(
                    function () {
                        let $curStar = $(this);
                        let $curStars = $curStar.parent().find('.rating-stars__star--inline');
                        curSelectedVal = $curStars.filter('.rating-stars__star--filled').length;

                        $curStars.removeClass('rating-stars__star--filled');
                        $curStar
                        .prevAll('.rating-stars__star--inline')
                        .addBack()
                        .addClass('rating-stars__star--hover');
                    },
                    function () {
                        let $curStar = $(this);
                        let $curStars = $curStar.parent().find('.rating-stars__star--inline');

                        $curStars.removeClass('rating-stars__star--hover');
                        let arrStars = $curStars.slice(0, curSelectedVal);
                        arrStars.each(function(idx, el) {
                            if(!$(el).hasClass('js-added-rating')){
                                $(el).addClass('rating-stars__star--filled');
                            }
                        });
                    }
                );
            });
        }

        function loadStars(){
            let elementsId = [];

            $ratingStars.each(function(idx, el) {
                elementsId.push($(el).attr('data-element-id'));
            });

            $.ajax({
                url: '/ajax/action/element_rate/getRatingElements/',
                data: { 'ids': elementsId },
                success: function (result){
                    if(result.data){
                        let dataArr = result.data;

                        for (const key in dataArr) {
                            let id = key;
                            let middleRating = dataArr[key];
                            let findEl = $(".js-rating-stars--inline[data-element-id='"+ id +"']");
                            let stars = findEl.find('.js-rating-item');

                            for(let i = 0; i < stars.length; i++){
                                if(i < Math.floor(middleRating)){
                                    if(!$(stars[i]).hasClass('rating-stars__star--filled')){
                                        $(stars[i]).addClass('rating-stars__star--filled');
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }

        loadStars();
        loadRatingHover();

        $ratingStars.find('.js-rating-item').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            if(!$(this).hasClass('js-rating-item')){
                return;
            }

            let $curStar = $(this);
            let elementId = $curStar.parent().attr('data-element-id');
            let rateEntityId = $curStar.parent().attr('data-rate-entity-id');

            $curStar
            .prevAll('.js-rating-item')
            .addBack()
            .addClass('rating-stars__star-yellow--filled');

            $curStar.parent().find('.js-rating-item').addClass('js-added-rating');

            $.ajax({
                url: '/ajax/action/element_rate/add/',
                data:
                    'rating=' +
                    $curStar.parent().find('.rating-stars__star-yellow--filled').length +
                    '&element_id=' +
                    elementId +
                    '&entity_id=' +
                    rateEntityId,
                success: function() {
                    $curStar.parent().find('.js-rating-item').removeClass('js-rating-item rating-stars__star--filled');
                }
            });
        });
    },

    initRatingStarsDetail: function (){

    }
}


// WEBPACK FOOTER //
// ./modules/rating.inline.js